export const CurrentProductUser = () => {
    return (
        <div data-testid="site-activation" data-cohort="current-product-user">
            Logged In Confluence Free - Current Product User
        </div>
    );
};
